// Function that returns the first or first two letters from a name
export const getInitials = (firstName?: string, lastName?: string) => {
  const safeFirstName = firstName?.trim() || ''
  const safeLastName = lastName?.trim() || ''

  return `${safeFirstName.charAt(0).toUpperCase()}${safeLastName.charAt(0).toUpperCase()}`
}

// Function that returns the formatted file size
export function formatBytes(bytes: any, decimals = 2) {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
